module.exports = __webpack_public_path__ + "media/header-mobile-cy.e405e5f0.mp4";